import { DiscountService } from './discount.service';
import { PaymentMethodsService } from './paymentMethods.service';
import { UserAssociatedService } from './userAssociated.service';

export const services = [PaymentMethodsService, UserAssociatedService, DiscountService];

export * from './discount.service';
export * from './paymentMethods.service';
export * from './userAssociated.service';
